import { RegistryItem } from '../RegistryItem';
export class SkeletonRegistryItem extends RegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    jsx = () => null;
    scope;
    isAspectWrapper = false;
    params;
}
